// IE11 and Safari do not support ScrollToOptions parameter
export default function windowScrollTo(scrollToOptions: ScrollToOptions): void {
  const isSmoothScrollSupported =
    'scrollBehavior' in document.documentElement.style

  isSmoothScrollSupported
    ? window.scrollTo(scrollToOptions)
    : window.scrollTo(scrollToOptions.left || 0, scrollToOptions.top || 0)
}
